Ext.ns('mx.tpl.lang');

mx.tpl.lang.USFormatter = Ext.extend(mx.tpl.lang.Formatter, {
    dateDivider: '.',
    isTwelveHourSystem: false,
    dateSequence: ['DAY', 'MONTH', 'YEAR'],
    addressSequence: ['ZIP', 'COUNTRY', 'COUNTY', 'DISTRICT', 'CITY', 'STREET', 'INFO'],
});
